import { SentryWebpackPluginOptions, sentryWebpackPluginFactory } from "./webpack4and5";

const createSentryWebpackPlugin = sentryWebpackPluginFactory();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sentryWebpackPlugin: (options?: SentryWebpackPluginOptions) => any =
  createSentryWebpackPlugin;

export { sentryCliBinaryExists } from "@sentry/bundler-plugin-core";

export type { SentryWebpackPluginOptions };
